module.exports = __webpack_public_path__ + "img/level02.e9fdf73c.png";